var LocationsGroupsComponentModule = /** @class */ (function () {
    function LocationsGroupsComponentModule() {
    }
    return LocationsGroupsComponentModule;
}());
export { LocationsGroupsComponentModule };
